<template>
  <UtilityVideoUploader v-model:path="videoPath"
                        :file="fileAnswer"
                        :btn-background="typeformData.primaryBackground"
                        :btn-foreground="typeformData.primaryForeground"
                        @update:path="updatePath"
                        @update:file="updateModelValue"
                        class="mt-1"/>
</template>

<script setup>
import UtilityVideoUploader from "./UtilityVideoUploader.vue";
import {computed, inject, nextTick, ref} from "vue";

const emits = defineEmits(["update:answer"]);
const props = defineProps({
  answer: Object,
});

const videoPath = ref("");
const videoFile = ref(null);

const typeformData = inject("typeformData", {});

const updatePath = async (path) => {
  videoPath.value = path;
  await nextTick();
  emits("update:answer", {
    value: videoFile.value,
    meta: {path},
  });
};

const updateModelValue = (value) => {
  videoFile.value = value;
  emits("update:answer", {
    value,
    meta: {
      path: videoPath.value,
    },
  });
};

const fileAnswer = computed(() => {
  if (!props.answer?.answer || !props.answer?.answer?.name) return null;
  return props.answer.answer;
});
</script>
